import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { BILLING_PATHS } from '../utils/paths';

/**
 * The tab that holds the card on file, which every "add or update your card" destination links to.
 *
 * Billing details replaces Payment methods under `billing-ui-2026` (SPE-4178), and the tab nav hides
 * whichever one the flag retires. Sending a flagged account to Payment methods therefore lands it on
 * a tab its own nav no longer offers — and for an account with no managed plan, on a redirect away
 * from the card form entirely — so the choice is made here once rather than at each call site.
 */
export function useCardTabHref(): string {
  const isBillingUI2026Enabled = useFeatureFlag(AccountFeatureFlag.BillingUI2026);
  return isBillingUI2026Enabled ? BILLING_PATHS.billingDetails : BILLING_PATHS.paymentMethods;
}
